import { Box, Stack, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useStores } from 'src/models';

// 사용자 기본 정보 컴포넌트
const BasicUserInfo = observer(() => {
  const { authStore, departmentStore } = useStores();
  const { user } = authStore;
  const { departments } = departmentStore;
  // 사용자 정보 조회
  const userName = user?.userNm || '';
  const dept = departments.find((dept) => dept.deptSid === user?.deptSid)?.deptNm || '';
  const job = user?.empJobrespCd?.value || '';
  const pos = user?.empPosCd?.value || '';

  return (
    <Stack spacing={1.25} sx={{ width: '100%' }}>
      <Box sx={{ width: '100%' }}>
        <Typography variant="caption" color="text.secondary">
          아이디
        </Typography>
        <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>
          {user?.loginId || '-'}
        </Typography>
      </Box>
      <Stack
        direction={'row'}
        spacing={1.5}
        sx={{
          '& > *': {
            flex: 1,
          },
          width: '100%',
          flexWrap: { xs: 'wrap', sm: 'nowrap' },
        }}
      >
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="caption" color="text.secondary">
            이름
          </Typography>
          <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
            {userName || '-'}
          </Typography>
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="caption" color="text.secondary">
            부서
          </Typography>
          <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
            {dept || '-'}
          </Typography>
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="caption" color="text.secondary">
            직책
          </Typography>
          <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
            {job || '-'}
          </Typography>
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="caption" color="text.secondary">
            직급
          </Typography>
          <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
            {pos || '-'}
          </Typography>
        </Box>
      </Stack>
    </Stack>
  );
});

export default BasicUserInfo;
